export default "__VITE_ASSET__DI4xbG9J__"